import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Delay Code Modals
 */
export const modalStyles = (theme: Theme): Record<string, SxProps<Theme>> => ({
  root: {
    "& .input-group-text": {
      display: "none",
    },
    "& .MuiDialogContent-dividers": {
      padding: 0,
    },
  },
  checkbox: {
    userSelect: "none",
  },
});
